// extracted by mini-css-extract-plugin
export default {"refreshMessage":"index-module__zymid"};